export default __webpack_public_path__ + "static/media/PaymentWasherLogo.6d7f46e9.png";